import { useState } from "react";
import {
  type PagingAction,
  usePagingActions,
} from "src/pages/ad-studio/insights/performance/view/use-paging-actions";

// A page belongs to the query it was turned on, so any other query starts again at the first page.
export function usePaging(query: string): {
  state: { page: number };
  performAction: (action: PagingAction) => void;
} {
  const [paged, setPaged] = useState({ query, page: 0 });
  const performAction = usePagingActions({ query, setPaged });
  return {
    state: { page: paged.query === query ? paged.page : 0 },
    performAction,
  };
}
